import { ChipGroup, EllipsisText, Text, type GridColDef } from '@shared/components';

import { BLOCKED_TYPE_LABEL_MAP, type PickRawBlockedRecordBlockedType } from '../../constants';

export interface BlockedUserListItem {
  id: string;
  nameTitle: string;
  firstName: string;
  middleName: string | null;
  lastName: string;
  idCard: string;
  blockedTypes: PickRawBlockedRecordBlockedType[];
  examCenterCodes: string[];
}

export const columns: GridColDef<BlockedUserListItem>[] = [
  {
    field: 'firstName',
    headerName: 'ชื่อ-นามสกุล',
    flex: 1,
    renderCell: ({ row }) => {
      const { nameTitle, firstName, middleName, lastName } = row;

      const fullName = [nameTitle, firstName, middleName, lastName].filter(Boolean).join(' ');
      return <EllipsisText>{fullName}</EllipsisText>;
    },
  },
  {
    field: 'idCard',
    headerName: 'เลขที่บัตรประชาชน',
    sortable: false,
    width: 240,
    renderCell: ({ row }) => {
      const { idCard } = row;
      return <EllipsisText>{idCard}</EllipsisText>;
    },
  },
  {
    field: 'blockTypes',
    headerName: 'ประเภทหน้าที่',
    sortable: false,
    width: 370,
    renderCell: ({ row }) => {
      const { blockedTypes } = row;

      if (blockedTypes.length === 0) {
        return <Text>-</Text>;
      }

      return (
        <ChipGroup
          labels={blockedTypes.map((blockType) => BLOCKED_TYPE_LABEL_MAP[blockType])}
          limit={2}
          direction='row'
        />
      );
    },
  },
  {
    field: 'examCenterCodes',
    headerName: 'ศูนย์ทดสอบ',
    sortable: false,
    width: 200,
    renderCell: ({ row }) => {
      const { examCenterCodes } = row;

      if (examCenterCodes.length === 0) {
        return <Text>-</Text>;
      }

      return <ChipGroup labels={examCenterCodes} limit={3} direction='row' />;
    },
  },
];
